import { ReactComponent as InfoIcon } from "icons/info.svg";
import { ReactComponent as ChannelIcon } from "icons/channel.svg";
import { ReactComponent as ShopIcon } from "icons/shop.svg";
import { ReactComponent as PlatformIcon } from "icons/platform.svg";
import { ReactComponent as PropertyIcon } from "icons/property.svg";
import { ReactComponent as PackageSizesIcon } from "icons/package_sizes.svg";

const getIcon = (icon) => {
  switch (icon) {
    case "info":
      return <InfoIcon />;
    case "channel":
      return <ChannelIcon />;
    case "shop":
      return <ShopIcon />;
    case "platform":
      return <PlatformIcon />;
    case "property":
      return <PropertyIcon />;
    case "package_sizes":
      return <PackageSizesIcon />;
    default:
      return null;
  }
};

const Dashboard = ({ header, children, footer }) => {
  const icon = getIcon(header?.icon);
  return (
    <div className="dashboard">
      {header?.title && (
        <header className="dashboard__header">
          {icon && <div className="icon__container">{icon}</div>}
          <h2 className="dashboard__title heading">{header.title}</h2>
          {header.aside}
        </header>
      )}
      {children}
      {footer && <div className="dashboard__footer">{footer}</div>}
    </div>
  );
};

export default Dashboard;
